import { SetMapInfo, SetWebPageInfo } from '../layouts/types';
import {
  API_AUTH_CERTS_FETCH_TYPE,
  API_AUTH_CERTS_RESET_TYPE,
  API_CANCEL_AUTH_TYPE,
  API_SERVICE_TYPE_TYPE,
  API_MAPS_SUCCESS_TYPE,
  API_WEBPAGES_SUCCESS_TYPE,
  API_AUTH_DUO_SUCCESS_TYPE,
  API_AUTH_DUO_ERROR_TYPE,
  API_AUTH_SET_DUO_TYPE,
  API_AUTH_DUO_FETCH_TYPE
} from '../../constants/API';
import { Action } from "redux";

import {
  API_AUTH_ERROR_TYPE,
  API_AUTH_FETCH_TYPE,
  API_AUTH_RESET_TYPE,
  API_AUTH_SUCCESS_TYPE,
  API_CAMERAS_ERROR_TYPE,
  API_CAMERAS_FETCH_TYPE,
  API_CAMERAS_SUCCESS_TYPE,
  API_GET_BOOKMARKS_INFO_TYPE,
  API_GET_DATA_TYPE,
  API_GET_EVENTS_INFO_TYPE,
  API_LAYOUTS_ERROR_TYPE,
  API_LAYOUTS_FETCH_TYPE,
  API_LAYOUTS_SUCCESS_TYPE,
  API_SESSION_TOKEN_IS_OVER_TYPE,
  API_SET_BOOKMARKS_INFO_TYPE,
  API_SET_EVENTS_INFO_TYPE,
  API_SET_GLOBAL_TRIGGERS_TYPE,
  API_AUTH_CERTS_TYPE,
  API_AUTH_SERVER_TYPE,
  API_SET_PRIVILLIDGES_TYPE
} from "../../constants/API";
import { SetCurrentStreamAction } from "../cameras/types";

//*******************API***********************

export enum serviceTypeEnum {
  ocularis = 1,
  cayuga = 2
}

export type tokenType = string | null | undefined;
export type errPayloadType = string | null | undefined;
export type triggerType = {
  label: string,
  trigger_id: string
};

export type BkmsInfo = {
  cases: any[],
  classifications: { id: number, name: string }[],
  tags: { id: number, name: string }[]
} | null;

export type PrivilegesType = {
  canBrowse: boolean,
  canCreateBookmarks: boolean,
  canDeleteBookmarks: boolean,
  canViewBookmarks: boolean
} | null;
export type ServiceType = 1 | 2 | null;


export interface APIState {
  authFetch: boolean,
  authCertsFetch: boolean,
  authDuoFetch: boolean,
  authError: boolean,
  authSuccess: boolean,
  authDuoSuccess: boolean,
  authDuoError: boolean,
  authCerts: boolean,
  authServer: boolean,
  authErrorMsg: errPayloadType,
  authErrorTitle: errPayloadType,
  token: tokenType,
  token2: tokenType,
  duoHost: string,
  sigRequest: string,
  camerasFetch: boolean,
  camerasSuccess: boolean,
  camerasError: boolean,
  cameras: any,
  maps: any,
  webPages: any,
  layoutsFetch: boolean,
  layoutsSuccess: boolean,
  layoutsError: boolean,
  layouts: any,
  username: string,
  bkmsInfo: BkmsInfo,
  sessionTokenIsOver: boolean,
  eventsInfo: any,
  globalTriggers: any[],
  privileges: PrivilegesType,
  serviceType: ServiceType
}

export interface HeadersLoginInterface {
  username: string,
  password: string
}

// *********** auth ********************
export interface AuthFetchActionInterface extends Action<API_AUTH_FETCH_TYPE> {
}

export interface AuthCertsFetchActionInterface extends Action<API_AUTH_CERTS_FETCH_TYPE> {
}

export interface AuthDuoFetchActionInterface extends Action<API_AUTH_DUO_FETCH_TYPE> {
}

export interface AuthSetDuoInterface extends Action<API_AUTH_SET_DUO_TYPE> {
  duoHost: string,
  sigRequest: string
}

export interface AuthDuoSuccessActionInterface extends Action<API_AUTH_DUO_SUCCESS_TYPE> {
  sigResponse: string
}

export interface AuthDuoErrorActionInterface extends Action<API_AUTH_DUO_ERROR_TYPE> {
}

export interface AuthSuccessActionInterface extends Action<API_AUTH_SUCCESS_TYPE> {
  username: string,
  token: string,
  token2?: string
}

export interface AuthErrorActionInterface extends Action<API_AUTH_ERROR_TYPE> {
  msg: string,
  title?: string
}

export interface AuthCertsActionInterface extends Action<API_AUTH_CERTS_TYPE> {
  auth: boolean
}

export interface AuthServerActionInterface extends Action<API_AUTH_SERVER_TYPE> {
}

export interface ServiceTypeActionInterface extends Action<API_SERVICE_TYPE_TYPE> {
  serviceType: ServiceType
}

export interface AuthResetActionInterface extends Action<API_AUTH_RESET_TYPE> {
}

export interface AuthCertsResetActionInterface extends Action<API_AUTH_CERTS_RESET_TYPE> {
}

export interface SetUserNameAction extends Action <'setUserName'> {
  name: string
}

export interface CancelAuthAction extends Action <API_CANCEL_AUTH_TYPE> {
}

export type AuthAction = AuthErrorActionInterface
  | AuthFetchActionInterface
  | AuthDuoFetchActionInterface
  | AuthSuccessActionInterface
  | AuthDuoSuccessActionInterface
  | AuthDuoErrorActionInterface
  | AuthSetDuoInterface
  | AuthResetActionInterface
  | AuthCertsResetActionInterface
  | AuthCertsActionInterface
  | AuthServerActionInterface
  | SetUserNameAction
  | AuthCertsFetchActionInterface
  | CancelAuthAction;

// ***************** cameras *********************

export interface APICamerasFetchInterface extends Action<API_CAMERAS_FETCH_TYPE> {
}

export interface APICamerasSuccessInterface extends Action<API_CAMERAS_SUCCESS_TYPE> {
  cameras: any
}

export interface APICamerasErrorInterface extends Action<API_CAMERAS_ERROR_TYPE> {
}

export interface APIMapsSuccessInterface extends Action<API_MAPS_SUCCESS_TYPE> {
  maps: any
}

export interface APIWebPagesSuccessInterface extends Action<API_WEBPAGES_SUCCESS_TYPE> {
  webPages: any
}

export type CamerasDataAction = APICamerasFetchInterface | APICamerasSuccessInterface | APICamerasErrorInterface;

//*******************layouts*********************************************
export interface APILayoutsFetchInterface extends Action<API_LAYOUTS_FETCH_TYPE> {
}

export interface APILayoutsSuccessInterface extends Action<API_LAYOUTS_SUCCESS_TYPE> {
  layouts: any
}

export interface APILayoutsErrorInterface extends Action<API_LAYOUTS_ERROR_TYPE> {
}

export type LayoutAction = APILayoutsFetchInterface | APILayoutsSuccessInterface | APILayoutsErrorInterface;

export interface GetAPIDataInterface extends Action<API_GET_DATA_TYPE> {
}

//******************bkms *********************

export interface GetBkmsInfo extends Action<API_GET_BOOKMARKS_INFO_TYPE> {
}

export interface APIGetEventsInfoAction extends Action<API_GET_EVENTS_INFO_TYPE> {
}

export interface SetBkmsInfo extends Action<API_SET_BOOKMARKS_INFO_TYPE> {
  bkmsInfo: any
}

export interface SetEventsInfoAction extends Action<API_SET_EVENTS_INFO_TYPE> {
  eventsInfo: any
}

export interface RunSetSessionTokenIsOverAction extends Action<API_SESSION_TOKEN_IS_OVER_TYPE> {
}

export interface APISetGlobalTriggersAction extends Action<API_SET_GLOBAL_TRIGGERS_TYPE> {
  globalTriggers: triggerType[]
}


export interface APISetPrivilegesAction extends Action<API_SET_PRIVILLIDGES_TYPE> {
  privileges: PrivilegesType
}

export type APIAction =
  AuthAction |
  CamerasDataAction |
  LayoutAction |
  GetBkmsInfo |
  SetBkmsInfo |
  RunSetSessionTokenIsOverAction |
  APIGetEventsInfoAction |
  SetEventsInfoAction |
  APISetGlobalTriggersAction |
  APISetPrivilegesAction |
  SetCurrentStreamAction |
  ServiceTypeActionInterface |
  APIMapsSuccessInterface |
  APIWebPagesSuccessInterface |
  SetMapInfo |
  SetWebPageInfo;
